import React, { useState, useEffect } from 'react';

const AnnouncementBar = () => {
  const [position, setPosition] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prevPosition) => {
        // Reset position when text goes off screen
        if (prevPosition <= -100) {
          return 100;
        }
        return prevPosition - 0.3; // Slower speed for better readability
      });
    }, 30); // Smoother animation

    return () => clearInterval(interval);
  }, []);

  const announcements = [
    "New Collection 2024 Available Now!",
    "Free Consultation for Interior Design Projects",
    "Special Discount on Kitchen Renovation - 20% OFF",
    "Luxury Bedroom Designs Starting at ₹5,000",
    "Book Your Free Design Consultation Today!",
    "Premium Quality Materials with 5 Year Warranty"
  ];

  return (
    <div className="relative w-full h-10 sm:h-12 overflow-hidden bg-gradient-to-r from-gray-900 via-black to-gray-900 border-b border-amber-900/30 shadow-lg">
      {/* Gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-transparent pointer-events-none"></div>
      
      {/* Animated text container */}
      <div className="absolute inset-0 flex items-center">
        <div 
          className="whitespace-nowrap text-sm sm:text-base font-semibold text-amber-400 tracking-wide"
          style={{
            transform: `translateX(${position}%)`,
            transition: 'transform 0.03s linear'
          }}
        >
          {/* Duplicate announcements for seamless infinite loop */}
          {announcements.map((announcement, index) => (
            <span key={index} className="mx-12 sm:mx-16 inline-flex items-center">
              <span className="material-symbols-outlined text-amber-500 mr-2 text-lg">campaign</span>
              {announcement}
            </span>
          ))}
          {announcements.map((announcement, index) => (
            <span key={`duplicate-${index}`} className="mx-12 sm:mx-16 inline-flex items-center">
              <span className="material-symbols-outlined text-amber-500 mr-2 text-lg">campaign</span>
              {announcement}
            </span>
          ))}
        </div>
      </div>

      {/* Side gradients for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-gray-900 via-gray-900/80 to-transparent pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-gray-900 via-gray-900/80 to-transparent pointer-events-none"></div>
    </div>
  );
};

export default AnnouncementBar;
